<template>
  <ancestryline-modal title="protocol.tab-general.actions.print-contracts"  id="protocol-printcontract-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select v-model="selectedClient" label="forms.contract.modal.client-to-be-attach" class="p-col-12" :options="clients"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('btn.save')" @click="save" class="p-ml-2 p-button-success"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalPrintContractAttach",

  props: {
    clientsPriceDTO: {type: Array, default: () => {return []}},
  },

  async mounted() {
    this.clients = this.clientsPriceDTO.map(cpd => cpd.client);
  },

  data(){
    return {
      selectedClient: {},
      clients: [],
    }
  },

  methods:{
    close(){
      DialogService.closeModal();
    },
    save(){
      if(this.selectedClient != null){
        const clientPriceDTO = this.clientsPriceDTO.find(item => item.client.id === this.selectedClient.id);
        DialogService.closeModal(clientPriceDTO);
      } else {
        this.close();
      }
    },
  }
}
</script>